import { types } from "mobx-state-tree";

export const AdminModel = types.model("AdminModel", {
  id: types.maybeNull(types.string),
  phoneNumber: types.maybeNull(types.string),
  role: types.maybeNull(
    types.enumeration(["admin", "marketing", "post", "shop", "category"])
  ),
});
